const CHECK_INTERVAL = 5 * 60 * 1000;
const DEPLOYED_VERSION_URL = '/version.json';
const fetchDeployedVersion = async () => {
    try {
        const response = await fetch(DEPLOYED_VERSION_URL, { cache: 'no-store' });
        if (!response.ok) {
            return null;
        }
        const { version } = await response.json();
        return version !== null && version !== void 0 ? version : null;
    }
    catch (_a) {
        return null;
    }
};
export const startVersionWatch = (onNewVersion) => {
    const checkDeployedVersion = async () => {
        if (document.visibilityState === 'hidden') {
            return;
        }
        const deployedVersion = await fetchDeployedVersion();
        if (deployedVersion !== null && deployedVersion !== global.VERSION) {
            onNewVersion();
        }
    };
    const handleVisibilityChange = () => {
        void checkDeployedVersion();
    };
    const intervalId = window.setInterval(() => {
        void checkDeployedVersion();
    }, CHECK_INTERVAL);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
        window.clearInterval(intervalId);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};
